import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DesignAngularKitModule } from 'design-angular-kit';

@Component({
  selector: 'app-confirm-structure-modal',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule, FormsModule],
  templateUrl: './confirm-structure-modal.component.html',
  styleUrl: './confirm-structure-modal.component.scss',
})
export class ConfirmStructureModalComponent {
  @Output() cancelled = new EventEmitter<void>();
  @Output() structureConfirmed = new EventEmitter<{
    facilityConfirmDate: Date | null;
  }>();

  facilityConfirmDate: Date | null = null;

  cancel(): void {
    this.cancelled.emit();
  }
  confirm() {
    this.structureConfirmed.emit({
      facilityConfirmDate: this.facilityConfirmDate,
    });
  }
}
